module.exports = __webpack_public_path__ + "6acf9d96.jpg";